import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-5",
  "use": "menu-5-usage",
  "viewBox": "0 0 36.99 43.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36.99 43.2\" id=\"menu-5\"><defs><style>#menu-5 .cls-1{opacity:.2}</style></defs><title>资源 11</title><g id=\"menu-5_图层_2\" data-name=\"图层 2\"><g id=\"menu-5_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M2.94 43.2h33.79l-2.36-26.5L23 29.27l-7.13-6.07L3 35.6l-.8 1.11zm0 0\" /><path d=\"M34.14 16.63h2.78V43.2h-2.78zM23 29.17h2.8v14H23zm-11.4-1.73h2.78V43.2H11.6zM.19 35.6H3v7.6H.19zM37 0L25.77 2.62l3.64 3.56-10.06 11-5.05-5L0 26.46l2 2 12.31-12.38 5.14 5.06 11.95-13 3.69 3.61zm0 0\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-5.svg
// module id = 8u6G
// module chunks = 6